import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { CurrencyCircleEuroIcon } from '@moia-dev/pace-icons'
import { PricingAreaRoutes } from './PricingAreaRoutes'

export const PricingAreaNavigationIcon = CurrencyCircleEuroIcon

export const PricingAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={PricingAreaRoutes.route}
      Icon={CurrencyCircleEuroIcon}
    />
  )
}
